import { useSelector } from "react-redux";
import ProfileCard from "../../components/profile-card/profile-card";
import ProfileMenu from "../../components/profile-menu/profile-menu";

const ProfilePage = () => {

    const { profile } = useSelector(store => store.user);
    return (
        <>
            <ProfileMenu />
            <ProfileCard profile={profile} />
        </>
    );
}

export default ProfilePage;